import React from 'react';
import './cards.css';

/**
 * Shared shell for every flow step card rendered inside the FlowSheet.
 * Role-tinted rail via `roleColorVar`.
 */
export default function FlowCard({ step, title, roleColorVar = '--color-role-ride', children, actions }) {
  return (
    <div className="flow-card" style={{ '--flow-role': `var(${roleColorVar})` }}>
      {step && <div className="flow-card-step">{step}</div>}
      {title && <h4 className="flow-card-title">{title}</h4>}
      {children && <div className="flow-card-content">{children}</div>}
      {actions && <div className="flow-card-actions">{actions}</div>}
    </div>
  );
}
